import { isFunction } from "./is.js";
import { wait } from "./wait.js";
async function nextTick(fn) {
  return wait().then(isFunction(fn) && fn);
}
export {
  nextTick as default
};
//# sourceMappingURL=nextTick.js.map
